import { render, staticRenderFns } from "./MdTableProvider.vue?vue&type=template&id=c2dc9cac&"
import script from "./MdTableProvider.vue?vue&type=script&lang=js&"
export * from "./MdTableProvider.vue?vue&type=script&lang=js&"
import style0 from "./MdTableProvider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports